
import { Vue, Prop, Component, Emit, Watch } from "vue-property-decorator";

@Component({})
export default class signUpInfo extends Vue {
  private userData: any[] = [];
  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  datas!: any;
  @Watch("datas", {
    immediate: true,
    deep: true,
  })
  watchDatas() {
    // console.log("this.datas", this.datas);
    this.userData = this.datas.form_UserVal;
    // console.log("userDataw", this.userData);
  }

  created() {}

  @Emit("handleEdit")
  handleEdit() {
    let isEdit = true;
    return isEdit;
  }
}
